import { render, staticRenderFns } from "./DecentralizationBalance.vue?vue&type=template&id=39379984&scoped=true&"
import script from "./DecentralizationBalance.vue?vue&type=script&lang=js&"
export * from "./DecentralizationBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39379984",
  null
  
)

export default component.exports